// Auto generated file, do not manually modify!
// com.hotpads.hotpadsapi.api.hp.webapi.v3.handler.listings.dto.HpPriceHistoryResponseDto.EventType

export enum EventType {
  LISTED_FOR_RENT = 'listedForRent',
  LISTING_REMOVED = 'listingRemoved',
  PRICE_CHANGED = 'priceChanged',
}

export const EventType_values = [
  EventType.LISTED_FOR_RENT,
  EventType.LISTING_REMOVED,
  EventType.PRICE_CHANGED,
] as const;
